import {
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import { useState } from 'react';
import {
  Box,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {CurrencyExchange, Menu} from "@mui/icons-material";
import SideBar from './SideBar';
import Login from '../pages/Login';
import Terms from '../pages/Terms';
import Registration from '../pages/Registration';
import ProtectedRoute from './ProtectedRoute';
import AdminRoute from './AdminRoute';
import Dashboard from '../pages/Dashboard';
import ApiKeysList from '../pages/ApiKeysList';
import NewApiKey from '../pages/NewApiKey';
import BulSmsSend from '../pages/BulSmsSend';
import SendSms from '../pages/SendSms';
import Business from '../pages/Business';
import Password from '../pages/Password';
import Pin from '../pages/Pin';
import SelcomPesaAccount from '../pages/SelcomPesaAccount';
import SentMessages from '../pages/SentMessages';
import ReqSenderId from '../pages/ReqSenderId';
import SenderIds from '../pages/SenderIds';
import NewEvent from '../pages/NewEvent';
import Events from '../pages/Events';
import ForgotPassword from '../pages/ForgotPassword';
import CreateCardHolder from '../pages/CreateCardHolder';
import CardHolders from '../pages/CardHolders';
import Cards from '../pages/Cards';
import CardDetail from '../pages/CardDetail';
import CardCreate from '../pages/CardCreate';
import ExchangeRates from '../pages/ExchangeRates';
import CurrencyExchangePage from '../pages/CurrencyExhangePage';
import Support from '../pages/Support';
import AdminSupport from '../pages/AdminSupport';
import AdminOverview from '../pages/AdminOverview';
import AdminUsers from '../pages/AdminUsers';
import AdminCollections from '../pages/AdminCollections';
import AdminPayouts from '../pages/AdminPayouts';
import AdminActivity from '../pages/AdminActivity';
import KycVerification from '../pages/KycVerification';
import Expenses from '../pages/Expenses';

function AppContent() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation(); // ✅ now safe here

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const noSidebarRoutes = ['/login', '/registration','/forgot-password', '/kyc-verification'];
  const shouldShowSidebar = !noSidebarRoutes.includes(location.pathname);

  const drawerWidth = mobileOpen ? 240 : 60;

  return (
    <Box sx={{ display: "flex" }}>
      {shouldShowSidebar && (
        <SideBar
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
        />
      )}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
        //   p: 3,
          width: shouldShowSidebar
            ? { sm: `calc(100% - ${drawerWidth}px)` }
            : "100%",
          ml: shouldShowSidebar ? { sm: `20px` } : 0,
          boxSizing: 'border-box' // Ensures padding is included in width calculation
        }}
      >
        
        {isMobile && shouldShowSidebar && !mobileOpen && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            px={2}
          >
            {/* <Typography
              variant="h6"
              sx={{
                fontSize: 14,
                fontWeight: 600,
                textTransform: "none",
                color: "#d32f2f",
              }}
            >
              ShopQik
            </Typography> */}
            <IconButton onClick={handleDrawerToggle}>
              <Menu/>
            </IconButton>
          </Box>
        )}
        <Routes>
          <Route path="/login" element={<Login/>} />
          <Route path="/terms" element={<Terms/>} />
          <Route path="/registration" element={<Registration/>} />
          <Route path="/forgot-password" element={<ForgotPassword/>} />
          <Route path="/kyc-verification" element={<ProtectedRoute><KycVerification/></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/expenses" element={<ProtectedRoute><Expenses /></ProtectedRoute>} />
          <Route path="/api-key-list" element={<ProtectedRoute><ApiKeysList/></ProtectedRoute>} />
          <Route path="/new-api-key" element={<ProtectedRoute><NewApiKey /></ProtectedRoute>} />
          <Route path="/bulk-sms" element={<ProtectedRoute><BulSmsSend /></ProtectedRoute>} />
          <Route path="/1-to-1-SMS" element={<ProtectedRoute><SendSms/></ProtectedRoute>} />
          <Route path="/business-info" element={<ProtectedRoute><Business/></ProtectedRoute>} />
          <Route path="/change-password" element={<ProtectedRoute><Password/></ProtectedRoute>} />
          <Route path="/change-pin" element={<ProtectedRoute><Pin/></ProtectedRoute>} />
          <Route path="/selcompesa-account" element={<ProtectedRoute><SelcomPesaAccount/></ProtectedRoute>} />
          <Route path="/messages" element={<ProtectedRoute><SentMessages/></ProtectedRoute>} />
          <Route path="/new-sender-id" element={<ProtectedRoute><ReqSenderId/></ProtectedRoute>} />
          <Route path="/sender-ids-list" element={<ProtectedRoute><SenderIds/></ProtectedRoute>} />
          <Route path="/new-event" element={<ProtectedRoute><NewEvent /></ProtectedRoute>} />
          <Route path="/events" element={<ProtectedRoute><Events/></ProtectedRoute>} />
          <Route path="/new-cardholder" element={<ProtectedRoute><CreateCardHolder/></ProtectedRoute>} />
          <Route path="/cardholders" element={<ProtectedRoute><CardHolders/></ProtectedRoute>} />
          <Route path="/cards" element={<ProtectedRoute><Cards/></ProtectedRoute>} />
          <Route path="/cards/new" element={<ProtectedRoute><CardCreate/></ProtectedRoute>} />
          <Route path="/cards/:cardId" element={<ProtectedRoute><CardDetail/></ProtectedRoute>} />
          <Route path="/exchange-rates" element={<ProtectedRoute><ExchangeRates/></ProtectedRoute>} />
          <Route path="/currency-exchange" element={<ProtectedRoute><CurrencyExchangePage/></ProtectedRoute>} />
          <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
          <Route path="/admin/support" element={<ProtectedRoute><AdminRoute><AdminSupport /></AdminRoute></ProtectedRoute>} />
          <Route path="/admin/overview" element={<ProtectedRoute><AdminRoute><AdminOverview /></AdminRoute></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute><AdminRoute><AdminUsers /></AdminRoute></ProtectedRoute>} />
          <Route path="/admin/collections" element={<ProtectedRoute><AdminRoute><AdminCollections /></AdminRoute></ProtectedRoute>} />
          <Route path="/admin/payouts" element={<ProtectedRoute><AdminRoute><AdminPayouts /></AdminRoute></ProtectedRoute>} />
          <Route path="/admin/activity" element={<ProtectedRoute><AdminRoute><AdminActivity /></AdminRoute></ProtectedRoute>} />
          {/* 
          <Route path="/add-new-category" element={<ProtectedRoute><AddNewCategory /></ProtectedRoute>} />
          <Route path="/subcategories" element={<ProtectedRoute><SubCategories /></ProtectedRoute>} />
          <Route path="/add-new-subcategory" element={<ProtectedRoute><AddNewSubCategory /></ProtectedRoute>} />
          <Route path="/products" element={<ProtectedRoute><Categories /></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute><Categories /></ProtectedRoute>} /> */}
          <Route path="*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        </Routes>
      </Box>
    </Box>
  );
}

export default AppContent;
